module.exports = "https://cdn.dove.it/_next/static/public/assets/altroconsumo/logo.fe1ab5cbd72e339f7d72a1355179783c.png";